
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./ActionsGuardrails": () => {
return Promise.all(/*  | __federation_expose_ActionsGuardrails */ [__webpack_require__.e("2438"), __webpack_require__.e("8661"), __webpack_require__.e("6725"), __webpack_require__.e("4920")]).then(() => (() => (__webpack_require__(75215))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };